import { render, staticRenderFns } from "./TreatmentHistoryTab.vue?vue&type=template&id=37ad5432&scoped=true"
import script from "./TreatmentHistoryTab.vue?vue&type=script&lang=js"
export * from "./TreatmentHistoryTab.vue?vue&type=script&lang=js"
import style0 from "./TreatmentHistoryTab.vue?vue&type=style&index=0&id=37ad5432&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ad5432",
  null
  
)

export default component.exports